var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoursePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 1.37895C11.1726 1.37895 13.0115 2.36932 14.1716 3.20028C15.546 4.18472 16.2533 5.13697 16.4367 5.50017C16.2531 5.86334 15.546 6.81558 14.1716 7.80006C13.0115 8.63099 11.1726 9.62136 8.99999 9.62136C6.82734 9.62136 4.98851 8.63099 3.82839 7.80006C2.45369 6.81558 1.74665 5.86334 1.56299 5.50017C1.74665 5.13697 2.45369 4.18472 3.82812 3.20028C4.98851 2.36932 6.82734 1.37895 8.99999 1.37895ZM8.99999 0.348633C4.30569 0.348633 0.5 4.46985 0.5 5.50017C0.5 6.53049 4.30569 10.6517 8.99999 10.6517C13.6943 10.6517 17.5 6.53046 17.5 5.50017C17.5 4.46988 13.6943 0.348633 8.99999 0.348633ZM8.99999 2.40927C7.29303 2.40927 5.90909 3.79321 5.90909 5.50017C5.90909 7.2071 7.29303 8.59107 8.99999 8.59107C10.7069 8.59107 12.0909 7.2071 12.0909 5.50017C12.0909 3.79321 10.7069 2.40927 8.99999 2.40927ZM8.16776 5.50017C7.44552 5.50017 6.86004 4.91469 6.86004 4.19244C6.86004 3.4702 7.44552 2.88475 8.16776 2.88475C8.89001 2.88475 9.47549 3.47023 9.47549 4.19244C9.47549 4.91469 8.89001 5.50017 8.16776 5.50017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePreview);
export default __webpack_public_path__ + "static/media/Course_Preview.6f677d4a8c805568943dfa7605746d3a.svg";
export { ForwardRef as ReactComponent };